import { ReactComponent as CheckIconSmall } from "assets/icons/check/check-16x16.svg";
import { ReactComponent as ChevronIconSmall } from "assets/icons/chevron/chevron-16x16.svg";
import React from "react";
import { Typography } from "render/ui/presentation/Typography";
import styles from "./styles.module.sass";

interface StepButtonProps extends React.ButtonHTMLAttributes<unknown> {
  completed: boolean;
}

export function StepButton({
  completed,
  children,
  disabled,
  ...props
}: StepButtonProps) {
  return (
    <button
      className={styles.StepButton}
      disabled={disabled}
      data-completed={completed}
      data-can-click={props.onClick != null}
      {...props}
    >
      <div className={styles.iconContainer}>
        <div className={styles.circle}>
          <CheckIconSmall />
        </div>
      </div>
      <div className={styles.todoText}>
        <Typography color={disabled ? "subtle" : "default"} variant="body-m">
          {children}
        </Typography>
      </div>
      {props.onClick && <ChevronIconSmall className={styles.chevron} />}
    </button>
  );
}
